import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCol, CFormInput, CFormLabel, CFormSwitch, CImage, CModal, CModalBody, CModalFooter, CModalHeader, CRow } from "@coreui/react"
import moment from "moment"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { deleteFrameAssignment, getCategories, getFrameAssignment, getFrameById, updateFrameAssignment } from "src/services/Frames"

const START_HOUR = ' 00:00:00'
const END_HOUR = ' 23:59:59'

function EditFrameAssignment() {
    const [assignment, setAssignment] = useState({})
    const [frame, setFrame] = useState({})
    const [categories, setCategories] = useState([])

    const [startingDates, setStartingDates] = useState([])
    const [startingIsTimePeriod, setStartingIsTimePeriod] = useState(false)

    const [showConfirm, setShowConfirm] = useState(false)

    const location = useLocation()
    const navigate = useNavigate()

    function isFormChanged(){
        if ((assignment.valid_from != startingDates[0]) && (assignment.valid_from != '')){
            return true
        }
        if ((assignment.valid_until != startingDates[1]) && (assignment.valid_until != '')){
            return true
        }
        if (assignment.is_time_period != startingIsTimePeriod){
            return true
        }
        return false
    }

    function handleUpdate(){
        updateFrameAssignment({
            ...assignment,
            valid_from : assignment.valid_from + START_HOUR,
            valid_until : assignment.valid_until + END_HOUR,
        }).then(
            navigate(-1)
        )
    }

    function handleDelete(){
        deleteFrameAssignment(assignment.id).then(
            navigate(-1)
        )
    }

    function fetchFrame() {
        getFrameById(assignment.frame_id).then(response => {
            let frameCat = ''
            categories.forEach(category => {
                if (category.id == response.data[0].category_id){
                    frameCat = category.name
                }
            })
            setFrame({...response.data[0], category_name : frameCat})
        })
    }

    function fetchFrameCategory(){
        getCategories().then(response => {
            setCategories(response.data)
        })
    }

    function fetchFrameAssignment() {
        getFrameAssignment(location.state.id).then(response => {
            setAssignment({
                ...response.data[0],
                valid_from : response.data[0].is_time_period == '1' ? moment(response.data[0].valid_from).format('YYYY-MM-DD') : '',
                valid_until : response.data[0].is_time_period == '1' ? moment(response.data[0].valid_until).format('YYYY-MM-DD') : '',
            })
            setStartingDates([
                response.data[0].is_time_period == '1' ? moment(response.data[0].valid_from).format('YYYY-MM-DD') : '',
                response.data[0].is_time_period == '1' ? moment(response.data[0].valid_until).format('YYYY-MM-DD') : ''
            ])
            setStartingIsTimePeriod(response.data[0].is_time_period)
        })
    }

    useEffect(() => {
        fetchFrameAssignment()
        fetchFrameCategory()
    }, [])

    useEffect(() => {
        if (assignment.frame_id && !(frame.id)){
            fetchFrame()
        }
    }, [assignment])

    useEffect (() => {
        if (frame.category_id && !(frame.category_name)){
            fetchFrameCategory()
        }
    }, [frame])

    const DeleteConfirmModal = () =>{
        return (
            <CModal visible={showConfirm} onClose={() => {setShowConfirm(false)}}>
                <CModalHeader>
                    Delete
                </CModalHeader>
                <CModalBody>
                    Are you sure?
                </CModalBody>
                <CModalFooter className="text-end">
                    <CButton color="secondary" className='text-light' onClick={() => {setShowConfirm(false)}}>
                        Cancel
                    </CButton>
                    <CButton color="danger" type="submit" className="text-light" onClick={() => handleDelete()}>
                        Delete
                    </CButton>
                </CModalFooter>
            </CModal>
        )
    }


    return (
        <>
            <DeleteConfirmModal/>
            <CCard className="mb-3">
                <CCardHeader>
                    Frame Detail
                </CCardHeader>
                <CCardBody>
                    <CRow>
                        <CCol xs={3}>
                            <CImage
                                align="center"
                                fluid
                                style={{
                                    maxHeight: '50vh'
                                }}
                                src={ frame.thumbnail_url }
                            />
                        </CCol>
                        <CCol xs={9}>
                            <CRow className="mb-1">
                                <CFormLabel className="col-sm-3 col-form-label">ID</CFormLabel>
                                <CCol sm={9}>
                                    <CFormInput defaultValue={frame.id} readOnly plainText/>
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CFormLabel className="col-sm-3 col-form-label">Name</CFormLabel>
                                <CCol sm={9}>
                                    <CFormInput defaultValue={frame.name} readOnly plainText/>
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CFormLabel className="col-sm-3 col-form-label">Category</CFormLabel>
                                <CCol sm={9}>
                                    <CFormInput defaultValue={frame.category_name} readOnly plainText/>
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CFormLabel className="col-sm-3 col-form-label">Img Count</CFormLabel>
                                <CCol sm={9}>
                                    <CFormInput defaultValue={frame.image_count} readOnly plainText/>
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CFormLabel className="col-sm-3 col-form-label">Use Count</CFormLabel>
                                <CCol sm={9}>
                                    <CFormInput defaultValue={frame.used_count} readOnly plainText/>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
            <CCard>
                <CCardHeader>
                    Frame Assignment Detail
                </CCardHeader>
                <CCardBody>
                    <CCol xs={9}>
                        <CRow className="mb-1">
                            <CFormLabel className="col-sm-3 col-form-label">ID</CFormLabel>
                            <CCol sm={9}>
                                <CFormInput defaultValue={assignment.id} readOnly plainText/>
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CFormLabel className="col-sm-3 col-form-label">Merchant</CFormLabel>
                            <CCol sm={9}>
                                <CFormInput defaultValue={assignment.merchant_name} readOnly plainText/>
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CFormLabel className="col-sm-3 col-form-label">Booth</CFormLabel>
                            <CCol sm={9}>
                                <CFormInput defaultValue={assignment.booth_id} readOnly plainText/>
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CFormLabel className="col-sm-3 col-form-label">Sequence</CFormLabel>
                            <CCol sm={9}>
                                <CFormInput defaultValue={assignment.sequence} readOnly plainText/>
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CFormLabel className="col-sm-3 col-form-label">Is Time Frame</CFormLabel>
                            <CCol sm={9} style={{display:'flex', alignItems: 'center'}}>
                                <CFormSwitch 
                                    checked={assignment.is_time_period == '1'} 
                                    onChange={()=>{
                                        const tar = assignment.is_time_period == '1' ? '0' : '1'
                                        setAssignment({...assignment, is_time_period : tar})
                                    }}
                                />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CFormLabel className="col-sm-3 col-form-label">Valid From</CFormLabel>
                            <CCol sm={9}>
                                <CFormInput 
                                    type="date" 
                                    value={assignment.valid_from}
                                    onChange={(e) => {
                                        setAssignment({...assignment, valid_from : e.target.value})
                                    }}
                                />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CFormLabel className="col-sm-3 col-form-label">Valid Until</CFormLabel>
                            <CCol sm={9}>
                                <CFormInput 
                                    type="date" 
                                    defaultValue={assignment.valid_until}
                                    onChange={(e) => {
                                        setAssignment({...assignment, valid_until : e.target.value})
                                    }}
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                </CCardBody>
                <CCardFooter className="text-end">
                    <CButton color="danger" className="text-light" style={{marginRight : '1rem'}} onClick={() => setShowConfirm(true)}>
                        Delete
                    </CButton>
                    <CButton disabled={!isFormChanged()} onClick={() => {handleUpdate()}}>
                        Update
                    </CButton>
                </CCardFooter>
            </CCard>
        </>
    )
}
export default EditFrameAssignment